import { WordFormState, WordModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class WordService extends BaseService<WordModel | WordFormState> {}

export default new WordService('words');
